import { useEffect } from 'react';
import { debounce } from "lodash";

function useResize(fn, delay = 1000) {
  useEffect(() => {
    const debouncedHandleResize = debounce(fn, delay);

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  });
}

export default useResize;
